(function HotelEngineFeaturedProperties($, Adzuki)
{
	'use strict';

	const component = {
		emits   : ['has-featured'],
		template: '#he-featured-properties',
		props   : {
			criteria: {
				type   : String,
				default: ''
			}
		},
		data() {
			return {
				baseUri           : Adzuki.base_uri,
				coordinates       : {},
				featuredProperties: {},
				formData          : {
					locationSearch: '',
					locationRadius: '',
					checkIn       : '',
					checkOut      : '',
					numRooms      : 1,
					rooms         : []
				},
			};
		},
		computed: {
		},
		methods: {
			async getFeaturedProperties() {
				let formData = new FormData();

				const structuredRooms = this.formData.rooms.map((room) => ({
					num_adults  : room.numAdults.toString(),
					num_children: room.numChildren.toString(),
					child_ages  : room.childrenAges.map((age) => age.toString())
				}));

				const location = {
					lat   : this.coordinates.lat,
					lng   : this.coordinates.lng,
					radius: this.formData.locationRadius
				};


				formData.append('check_in', this.formData.checkIn);
				formData.append('check_out', this.formData.checkOut);
				formData.append('rooms', JSON.stringify(structuredRooms));
				formData.append('location', JSON.stringify(location));

				const response = await fetch(this.baseUri + '/HotelEngine/vueFeaturedProperties', {
					method: 'POST',
					body  : formData,
				});

				const featuredProperties = await response.json();

				this.featuredProperties = featuredProperties;
				this.$emit('has-featured');
			},
			truncateString(string, maxLength) {
				if (string) {
					if (string.length > maxLength) {
						return string.substring(0, maxLength) + '...';
					}
					return string;
				}
				return null;
			},
			displaySpecialtyRateCode(code) {
				return Adzuki.HotelEngine.displaySpecialtyRateCode(code);
			},
			jsonToFormData(jsonString, form) {
				const json     = JSON.parse(jsonString);

				// Iterate through each key-value pair in the JSON object
				Object.keys(json).forEach((key) => {
					if (Array.isArray(json[key])) {
						json[key].forEach((value) => form.append(`${key}[]`, value));
					} else if (typeof json[key] === "object" && json[key] !== null) {
						Object.keys(json[key]).forEach((subKey) =>
							form.append(`${key}[${subKey}]`, json[key][subKey])
						);
					} else {
						form.append(key, json[key]);
					}
				});

				return form;
			},
		},
		watch: {
			criteria: {
				handler() {
					try {
						const storedFormData    = sessionStorage.getItem('formData');
						const storedCoordinates = sessionStorage.getItem('coordinates');

						this.formData.rooms = [];

						if (storedFormData) {
							this.skipRoomsWatcher = true;
							const parsedFormData  = JSON.parse(storedFormData);

							this.formData.locationSearch = parsedFormData.locationSearch;
							this.formData.locationRadius = parsedFormData.locationRadius;
							this.formData.checkIn        = parsedFormData.checkIn;
							this.formData.checkOut       = parsedFormData.checkOut;
							this.formData.numRooms       = parsedFormData.numRooms;

							parsedFormData.rooms.forEach(room => {
								this.formData.rooms.push({
									roomNumber  : room.roomNumber || 1,
									numAdults   : room.numAdults || 2,
									numChildren : room.numChildren || 0,
									childrenAges: room.childrenAges || []
								});
							});

							this.skipRoomsWatcher = false;
						}

						if (storedCoordinates) {
							this.coordinates = JSON.parse(storedCoordinates);
						}

					} catch (error) {
						console.error('Error parsing local storage data:', error);
					}

					this.getFeaturedProperties();
				}
			}
		},
		mounted() {
			try {
				const storedFormData    = sessionStorage.getItem('formData');
				const storedCoordinates = sessionStorage.getItem('coordinates');

				this.formData.rooms = [];

				if (storedFormData) {
					this.skipRoomsWatcher = true;
					const parsedFormData  = JSON.parse(storedFormData);

					this.formData.locationSearch = parsedFormData.locationSearch;
					this.formData.locationRadius = parsedFormData.locationRadius;
					this.formData.checkIn        = parsedFormData.checkIn;
					this.formData.checkOut       = parsedFormData.checkOut;
					this.formData.numRooms       = parsedFormData.numRooms;

					parsedFormData.rooms.forEach(room => {
						this.formData.rooms.push({
							roomNumber  : room.roomNumber || 1,
							numAdults   : room.numAdults || 2,
							numChildren : room.numChildren || 0,
							childrenAges: room.childrenAges || []
						});
					});

					this.skipRoomsWatcher = false;
				}

				if (storedCoordinates) {
					this.coordinates = JSON.parse(storedCoordinates);
				}

			} catch (error) {
				console.error('Error parsing local storage data:', error);
			}

			this.getFeaturedProperties();
		}
	};

	Adzuki.VueComponents.HotelEngineFeaturedProperties = component;
}(jQuery, window.Adzuki || {}));
